<template>
  <b-row>
    <b-col cols="12" class="container-fluid">
      <b-card>
          <b-row>
            <b-col cols="12" md="12">
              <h4>คู่มือการสร้าง Token สำหรับ Webex</h4>
            </b-col>
            <b-col cols="12" md="12">
              <ol style="line-height: 1.8;">
                <li>
                  เข้าสู่ระบบ <strong>Webex Developer</strong> โดยไปที่ 
                  <a href="https://developer.webex.com/" target="_blank">developer.webex.com</a>
                </li>

                <li>
                  หลังจากเข้าสู่ระบบเรียบร้อยแล้ว คลิกที่มุมขวาบน จากนั้นเลือกเมนู 
                  <strong>My Webex Apps</strong><br/>
                  <img :src="book.image" alt="ขั้นตอนการเข้าสู่ My Webex Apps" style="margin: 10px 0; max-width: 100%;" />
                </li>

                <li>
                  เลือกแอปพลิเคชัน <strong>ServiceOCPBMediateMirroriste</strong><br/>
                  <img :src="book.image2" alt="เลือก ServiceOCPBMediateMirroriste" style="margin: 10px 0; max-width: 100%;" />
                </li>

                <li>
                  ในหัวข้อ <strong>Org Authorizations</strong> ให้คลิกที่ 
                  <strong>Authorized orgs</strong> และเลือก <strong>OCPB</strong><br/>
                  <img :src="book.image3" alt="เลือก Authorized orgs" style="margin: 10px 0; max-width: 100%;" />
                </li>

                <li>
                  กรอกค่า <strong>Client Secret</strong> จากนั้นคลิกที่ปุ่ม 
                  <strong>Generate Tokens</strong><br/>
                  <img :src="book.image4" alt="กรอก Client Secret และ Generate Token" style="margin: 10px 0; max-width: 100%;" />
                </li>

                <li>
                  ระบบจะแสดงค่า <strong>refresh_token</strong> และ <strong>access_token</strong> ให้คัดลอกเพื่อนำไปใช้งานในระบบ
                </li>
              </ol>
            </b-col>
            <b-col cols="12" md="12">
              <p style="color:red;">
                <strong>หมายเหตุ:</strong> ค่า <strong>refresh_token</strong> และ <strong>access_token</strong> จะแสดงเพียงครั้งเดียว 
                และจะไม่ถูกบันทึกไว้ หากทำหายหรือไม่ได้บันทึก จะต้องดำเนินการสร้างโทเค็นใหม่เท่านั้น
              </p>
            </b-col>
          </b-row>
        <WebexTokenManage :routeName="$route.name"/>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
} from "bootstrap-vue";
import commonTable from "./components/commonTable.vue";
import SearchFilter from "./components/SearchFilter.vue";
import WebexTokenManage from './WebexTokenManage.vue';
import WebexToken_1 from '@/assets/images/WebexToken/WebexToken_1.png';
import WebexToken_2 from '@/assets/images/WebexToken/WebexToken_2.png';
import WebexToken_3 from '@/assets/images/WebexToken/WebexToken_3.png';
import WebexToken_4 from '@/assets/images/WebexToken/WebexToken_4.png';


export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    commonTable,
    SearchFilter,
    WebexTokenManage,
  },
  props: {
    routeName: String,
  },
  data() {
    return {
      book: {
        image: WebexToken_1,
        image2: WebexToken_2,
        image3: WebexToken_3,
        image4: WebexToken_4,
      },
    };
  },
  methods: {
    searchFilterSubmit(params) {
      // this.$refs.tableCommon.onSearchSubmit(params);
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
